import {
    SHOW_MULTI_PDP_VISITS,
    NOTIFICATION_KEYS as SHARED_NOTIFICATION_KEYS,
} from '../pdp/PdpSharedNotifications/pdpSharedNotificationConstants.js';

const resetNotifications = notifications => {
    return Object.keys(notifications).map(key => ({ [key]: false }));
};

export function pdpRespNotificationsReducer(state, action) {
    switch (action.type) {
        case SHOW_MULTI_PDP_VISITS:
            return {
                ...state,
                notifications: {
                    ...resetNotifications(state.notifications),
                    [SHARED_NOTIFICATION_KEYS.MULTI_PDP_VISITS]: {
                        isEnabled: true,
                    },
                },
            };
        default:
            return state || { notifications: {} };
    }
}
